import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { GeneralService } from "../general.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Component({
  selector: "app-admin-dashboard",
  templateUrl: "./admin-dashboard.component.html",
  styleUrls: ["./admin-dashboard.component.css"],
})
export class AdminDashboardComponent implements OnInit {
  public lineChartType = "line";
  public lineChartPlugins = [];

  fromDate: any;
  toDate: any;
  countArray: any;
  followupPercentage;
  today: any;

  public DoughnutChartOptions: any = {
    legend: {
      position: "bottom",
      display: false,
      labels: {
        padding: 20,
        boxWidth: 20,
      },
    },
  };
  http: any;

  constructor(
    private router: Router,
    private gs: GeneralService,
    http: HttpClient
  ) {
    this.http = http;
  }

  ngOnInit() {
    this.fromDate = new Date();
    this.toDate = new Date();
    this.today = new Date();
  }

  addPatientData() {
    this.router.navigate(["addPatientData"]);
  }
  
}
